import React from 'react';

import CircularIndeterminate from "components/loaders/circularIndeterminate";

function Loader() {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '24px 0',
        }}>
            <CircularIndeterminate />
        </div>
    );
}

export default Loader;
